var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentFormBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1163_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0672 13.2959C26.6632 12.6558 27.276 12.2512 28.0369 12.0889C28.6932 11.9479 29.3767 12.0086 29.9979 12.2631C30.6191 12.5175 31.1488 12.9537 31.5177 13.5146C31.8846 14.0749 32.0743 14.7327 32.0619 15.4024C32.0494 16.072 31.8355 16.7224 31.448 17.2687C31.2902 17.4804 31.116 17.6794 30.927 17.8638C29.3779 19.4138 27.8217 20.9558 26.2797 22.5137C26.151 22.6531 26.076 22.8337 26.0681 23.0233C26.0522 24.8598 26.0681 26.6972 26.0558 28.5346C26.0452 30.29 24.9784 31.6204 23.335 31.9422C23.1071 31.9825 22.8759 32.0008 22.6446 31.9969C16.2379 32.0004 9.83403 32.0004 3.43315 31.9969C1.72889 31.9969 0.396699 30.9204 0.0740094 29.3025C0.0269189 29.0316 0.00625135 28.7567 0.0122946 28.4817C0.0122946 20.1641 0.0228733 11.8474 -5.00087e-05 3.53061C-0.00445833 1.59095 1.31363 0.31254 2.73311 0.0621471C2.99562 0.0219343 3.26107 0.00394328 3.52661 0.00836549C8.49743 0.00836549 13.4683 0.00601423 18.4391 0.00131202C18.6135 -0.00509948 18.7872 0.0259765 18.9486 0.0924422C19.11 0.158908 19.2552 0.259217 19.3745 0.386599C21.4729 2.49319 23.5789 4.59184 25.6925 6.68256C25.8196 6.80294 25.9192 6.94927 25.9846 7.11161C26.05 7.27394 26.0797 7.44846 26.0716 7.6233C26.0628 9.36106 26.0716 11.0997 26.0716 12.8375L26.0672 13.2959ZM18.0344 1.33615H17.6914C12.9628 1.33615 8.2344 1.33615 3.50633 1.33615C2.16003 1.33615 1.34625 2.14993 1.34625 3.49358C1.34625 11.8324 1.34625 20.1714 1.34625 28.5108C1.34625 29.8527 2.16179 30.6674 3.50809 30.6674C9.85607 30.6674 16.2041 30.6674 22.552 30.6674C23.8983 30.6674 24.713 29.8545 24.7165 28.5126C24.7165 27.1486 24.7165 25.7847 24.7165 24.4208C24.7165 24.3326 24.7015 24.2374 24.6901 24.1016C24.5658 24.2197 24.4785 24.3 24.3947 24.3837C23.2247 25.5502 22.0627 26.7237 20.8804 27.8769C20.6761 28.0725 20.4284 28.217 20.1574 28.2983C18.5493 28.7559 16.9341 29.1879 15.3197 29.6208C14.6479 29.8024 14.2335 29.3845 14.416 28.7109C14.8569 27.1001 15.2889 25.4876 15.7482 23.8829C15.8256 23.6225 15.9654 23.3849 16.1556 23.1908C18.9287 20.4048 21.7065 17.6234 24.4891 14.8468C24.6194 14.7092 24.6968 14.5299 24.7077 14.3407C24.7227 12.3384 24.7174 10.3362 24.7165 8.33392C24.7165 8.229 24.7077 8.12496 24.7024 8.00241H21.4597C20.7604 8.0173 20.0742 7.8112 19.4988 7.41346C18.5158 6.72312 18.0414 5.76387 18.0335 4.57186C18.0291 3.51122 18.0344 2.44617 18.0344 1.33615ZM20.1821 26.5517L28.6055 18.1442C27.7151 17.2625 26.7893 16.3385 25.8821 15.4384C23.0943 18.2271 20.2729 21.0387 17.4604 23.8459L20.1821 26.5517ZM29.6918 17.1814C30.4491 16.574 30.9314 15.8378 30.6528 14.8133C30.4324 14.0021 29.8725 13.526 29.0481 13.392C28.103 13.2386 27.4268 13.6927 26.8863 14.3821L29.6918 17.1814ZM19.4195 2.45234C19.4195 3.28022 19.341 4.18569 19.4424 5.07088C19.5306 5.89171 20.1116 6.49124 20.928 6.59351C21.8326 6.70637 22.7619 6.61908 23.6021 6.61908L19.4195 2.45234ZM18.8623 27.2774C18.1569 26.5623 17.471 25.8729 16.7771 25.1719C16.5232 26.11 16.2675 27.0516 15.9933 28.0612L18.8623 27.2774Z",
    fill: "url(#paint0_linear_1163_17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34554 16.667C4.71691 16.667 4.08917 16.667 3.46054 16.667C2.91832 16.667 2.68115 16.4254 2.68027 15.8735C2.68027 14.6303 2.68027 13.3872 2.68027 12.144C2.68027 11.5974 2.91744 11.3408 3.45349 11.3373C4.72073 11.3303 5.98798 11.3303 7.25522 11.3373C7.77364 11.3373 8.02227 11.6018 8.02403 12.1185C8.02815 13.3722 8.02815 14.6262 8.02403 15.8805C8.02403 16.4228 7.77452 16.6608 7.23054 16.6635C6.60191 16.6696 5.97328 16.667 5.34554 16.667ZM6.68038 12.6995H4.03538V15.3172H6.68038V12.6995Z",
    fill: "url(#paint1_linear_1163_17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68025 6.66882C2.68025 6.0305 2.68025 5.39218 2.68025 4.75473C2.68025 4.25836 2.93594 3.99826 3.43496 3.99562C4.71337 3.98974 5.99178 3.98974 7.2702 3.99562C7.76217 3.99562 8.02049 4.26012 8.02226 4.76002C8.02813 6.02492 8.02813 7.2901 8.02226 8.55559C8.02226 9.07136 7.75776 9.32881 7.24728 9.33057C5.97944 9.33527 4.7119 9.33527 3.44466 9.33057C2.92977 9.33057 2.6829 9.07224 2.67937 8.5503C2.67761 7.92255 2.67937 7.29569 2.68025 6.66882ZM4.03096 7.9781H6.66538V5.34897H4.03096V7.9781Z",
    fill: "url(#paint2_linear_1163_17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32526 24.0059C4.70809 24.0059 4.09093 24.0059 3.47376 24.0059C2.92008 24.0059 2.68027 23.7688 2.68027 23.2274C2.68027 21.9737 2.68027 20.72 2.68027 19.4663C2.68027 18.9373 2.91479 18.6913 3.44026 18.6895C4.71867 18.6842 5.99679 18.6842 7.27462 18.6895C7.7754 18.6895 8.02139 18.9417 8.02315 19.4486C8.02903 20.7135 8.02903 21.9772 8.02315 23.2398C8.02315 23.7573 7.76835 23.998 7.242 24.0024C6.6072 24.0095 5.96447 24.0059 5.32526 24.0059ZM4.03891 20.0332V22.6561H6.67597V20.0332H4.03891Z",
    fill: "url(#paint3_linear_1163_17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0292 12.0039C13.9438 12.0039 14.8581 12.0039 15.7721 12.0039C15.9151 11.9994 16.0582 12.0107 16.1988 12.0374C16.3354 12.0639 16.459 12.1358 16.5496 12.2415C16.6402 12.3471 16.6924 12.4802 16.6978 12.6193C16.7137 12.763 16.6796 12.9078 16.6012 13.0294C16.5229 13.1509 16.4051 13.2418 16.2676 13.2867C16.119 13.3266 15.9655 13.345 15.8118 13.3414C13.9603 13.3449 12.1088 13.3449 10.2573 13.3414C10.1473 13.3442 10.0373 13.3377 9.92843 13.322C9.76871 13.2998 9.62268 13.2197 9.51803 13.097C9.41338 12.9744 9.35738 12.8175 9.36064 12.6563C9.36144 12.4949 9.42353 12.3398 9.53435 12.2225C9.64516 12.1051 9.79643 12.0342 9.95752 12.0242C10.23 11.9968 10.5068 12.0056 10.7828 12.0048C11.5304 12.003 12.2792 12.0027 13.0292 12.0039Z",
    fill: "url(#paint4_linear_1163_17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0513 19.3571C14.0096 19.3571 14.9689 19.3571 15.9273 19.3571C16.4166 19.3571 16.7023 19.6093 16.7005 20.0193C16.6987 20.4292 16.4025 20.684 15.922 20.6849C13.9935 20.6849 12.0653 20.6849 10.1374 20.6849C9.66569 20.6849 9.36063 20.4116 9.36151 20.014C9.36239 19.6163 9.65511 19.3589 10.1427 19.3571C11.1125 19.3545 12.0814 19.3571 13.0513 19.3571Z",
    fill: "url(#paint5_linear_1163_17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.031 5.99703C12.1052 5.99703 11.1798 5.99703 10.2546 5.99703C10.1335 6.00046 10.0123 5.99368 9.89226 5.97675C9.75031 5.95151 9.62097 5.87928 9.52503 5.77166C9.42908 5.66404 9.37211 5.5273 9.36326 5.38339C9.35102 5.23922 9.38792 5.09515 9.46796 4.97461C9.548 4.85407 9.66647 4.76416 9.80409 4.7195C9.95212 4.68205 10.1046 4.66543 10.2573 4.67013C12.1082 4.6666 13.9597 4.6666 15.8118 4.67013C15.9325 4.66656 16.0534 4.67543 16.1724 4.69658C16.331 4.72541 16.4732 4.81244 16.5711 4.94062C16.6689 5.06881 16.7154 5.22891 16.7013 5.38956C16.6919 5.54495 16.6261 5.69158 16.5165 5.80206C16.4068 5.91255 16.2607 5.97934 16.1053 5.98998C15.9414 6.00673 15.7756 6.00056 15.6107 6.00144C14.7502 5.99967 13.8903 5.99821 13.031 5.99703Z",
    fill: "url(#paint6_linear_1163_17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.003 8.66576C11.3541 8.66576 10.7043 8.66576 10.0554 8.66576C9.92202 8.6719 9.78997 8.63721 9.67686 8.56631C9.56375 8.49542 9.47495 8.3917 9.42234 8.26901C9.30949 8.02567 9.32624 7.77087 9.5158 7.59718C9.66381 7.45679 9.85485 7.37043 10.058 7.35208C11.3673 7.33092 12.6774 7.33621 13.9867 7.34238C14.4126 7.34238 14.7017 7.62628 14.7 8.00187C14.6982 8.37746 14.4055 8.65959 13.9841 8.66576C13.3237 8.67281 12.6633 8.66576 12.003 8.66576Z",
    fill: "url(#paint7_linear_1163_17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0382 16.002C11.3999 16.002 10.7616 16.002 10.1233 16.002C9.65511 16.002 9.3527 15.7234 9.36152 15.3214C9.37033 14.9193 9.65864 14.6777 10.1206 14.676C11.3979 14.6725 12.6748 14.6725 13.9515 14.676C14.3993 14.676 14.6991 14.9511 14.7 15.3364C14.7009 15.7216 14.3976 15.9976 13.9532 16.0011C13.3149 16.0055 12.6766 16.002 12.0382 16.002Z",
    fill: "url(#paint8_linear_1163_17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0391 23.3412C11.4008 23.3412 10.7625 23.3412 10.1242 23.3412C9.6463 23.3412 9.3527 23.0705 9.36152 22.6658C9.37034 22.2805 9.67099 22.0152 10.1206 22.0143C11.3973 22.0096 12.6742 22.0096 13.9515 22.0143C14.3967 22.0143 14.6991 22.2929 14.7 22.6782C14.7009 23.0634 14.4029 23.3359 13.9541 23.3403C13.3158 23.3456 12.6775 23.3412 12.0391 23.3412Z",
    fill: "url(#paint9_linear_1163_17)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1163_17",
    x1: 16.0312,
    y1: 0.000488281,
    x2: 16.0312,
    y2: 31.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E296C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5950D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1163_17",
    x1: 5.35369,
    y1: 11.332,
    x2: 5.35369,
    y2: 16.6675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E296C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5950D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1163_17",
    x1: 5.35264,
    y1: 3.99121,
    x2: 5.35264,
    y2: 9.3341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E296C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5950D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1163_17",
    x1: 5.35391,
    y1: 18.6855,
    x2: 5.35391,
    y2: 24.0068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E296C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5950D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1163_17",
    x1: 13.0311,
    y1: 12.0029,
    x2: 13.0311,
    y2: 13.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E296C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5950D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1163_17",
    x1: 13.031,
    y1: 19.356,
    x2: 13.031,
    y2: 20.6849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E296C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5950D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1163_17",
    x1: 13.0324,
    y1: 4.66748,
    x2: 13.0324,
    y2: 6.00185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E296C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5950D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1163_17",
    x1: 12.0259,
    y1: 7.33691,
    x2: 12.0259,
    y2: 8.6689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E296C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5950D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1163_17",
    x1: 12.0307,
    y1: 14.6733,
    x2: 12.0307,
    y2: 16.0033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E296C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5950D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1163_17",
    x1: 12.0307,
    y1: 22.0107,
    x2: 12.0307,
    y2: 23.3429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E296C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5950D2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1163_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.0617,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentFormBlue);
export default __webpack_public_path__ + "static/media/agentFormBlue.2a40e6dfb063ba54cf4f365246d92ede.svg";
export { ForwardRef as ReactComponent };